export function LaneLoadMore({
  remaining,
  loading,
  onClick,
}: {
  remaining: number
  loading: boolean
  onClick: () => void
}) {
  return (
    // A plain button, not the shared Button: this is the Action Center board's own Load more,
    // and its markup is pinned by the board parity snapshots.
    <button
      type="button"
      disabled={loading}
      onClick={onClick}
      className="mt-2 shrink-0 rounded-lg border border-default px-3 py-1.5 text-body-xs text-subtle transition hover:border-strong hover:text-strong disabled:text-minimal"
    >
      {loading ? `Loading more` : `Load more · ${remaining.toLocaleString(`en-US`)} still to come`}
    </button>
  )
}
